import { getSignature } from 'apis/contacts.api';
import SignatureUpload from 'features/ScientificProfile/components/SignatureUpload';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { autoDownloadFile, convertDataToUrl } from 'utils/func';

export default function Signature({ reviewerInfo, refetchReviewerInfo, readOnly }) {
  const { t } = useTranslation();
  const [signaturePreview, setSignaturePreview] = useState(null);

  const [isSignatureDialogOpen, setIsSignatureDialogOpen] = useState(false);

  const signatureUrl = useMemo(() => reviewerInfo?.signatureUrl ?? null, [reviewerInfo]);

  const { refetch: downloadSignatureFile } = useQuery(
    'downloadSignatureFile',
    () => getSignature(reviewerInfo?.id),
    {
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
    }
  );

  const { refetch: refetchPreviewSignature } = useQuery(
    'downloadPreviewSignatureFile',
    () => getSignature(reviewerInfo?.id),
    {
      enabled: !!reviewerInfo?.id,
      onSuccess: async (res) => {
        if (res.data.size > 0) {
          const imageBlob = new Blob([res.data]);

          const imageUrl = await convertDataToUrl(imageBlob);
          setSignaturePreview(imageUrl);
        }
      },
    }
  );

  return (
    <div className={!signatureUrl && !readOnly ? 'signature-missing' : ''}>
      <img
        src={signaturePreview || '/images/default-signature.png'}
        alt="user profile"
        className="w-20rem h-auto"
        style={{ border: !signatureUrl && !readOnly ? '2px solid #ef4444' : 'none' }}
      />
      {!signatureUrl && !readOnly && (
        <p className="text-red-500 font-bold mt-2 mb-0">
          <i className="pi pi-exclamation-triangle mr-1" />
          {t('signature.required')}
        </p>
      )}
      <p className="font-bold">{reviewerInfo?.fullname}</p>
      {!readOnly && (
        <>
          <Button
            label={t('userProfile.uploadSignature')}
            icon="pi pi-cloud-upload"
            className={`hover:opacity-80 w-10rem ${
              !signatureUrl ? 'border-red-400 text-red-500' : 'border-orange-400 text-orange-400'
            }`}
            onClick={() => setIsSignatureDialogOpen(true)}
            outlined
            type="button"
            severity={!signatureUrl ? 'danger' : undefined}
          />

          <SignatureUpload
            contactId={reviewerInfo?.id}
            fileUrl={signatureUrl}
            visible={isSignatureDialogOpen}
            setVisible={setIsSignatureDialogOpen}
            refetch={refetchReviewerInfo}
            refetchPreview={refetchPreviewSignature}
            handleDownloadFile={downloadSignatureFile}
            readOnly={readOnly}
          />
        </>
      )}
    </div>
  );
}

Signature.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  reviewerInfo: PropTypes.object.isRequired,
  refetchReviewerInfo: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

Signature.defaultProps = {
  readOnly: false,
};
